import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getString } from '../../helpers/stringHelpers.js';
import { getLoadedStatus } from '../../helpers/loaderHelpers';
import withLoader from '../../components/Loader/withLoader.js';

// Actions
import { actions as routingActions } from '../../ducks/routing.js';
import { actions as authActions } from '../../ducks/auth.js';
import { actions as appActions } from '../../ducks/app.js';
import { actions as customerActions } from '../../ducks/customer.js';

// Components
import ApplicationsIcon from '@material-ui/icons/PhoneAndroid';

import ApplicationChildLayout from './ApplicationChildLayout';
import ApplicationChildCard from './ApplicationChildCard/ApplicationChildCard';
import Replace from '../../components/Replace/Replace';

const stringsComponent = 'fencingApplications';

class ApplicationChild extends React.Component {
  state = {
    hasLoaded: false,
  };

  componentDidMount() {
    const { setAppBarTitle, onLoadComplete } = this.props;
    const currentPage = this.getCurrentPage();
    setAppBarTitle(currentPage.appBarTitle);
    onLoadComplete();
  }

  componentDidUpdate() {
    const { hasLoaded } = this.state;

    if (
      getLoadedStatus(this.getLoadedStatuses(this.props)) == 'LOADED' &&
      !hasLoaded
    ) {
      // Once all required data has loaded, store that fact.
      this.setState({ hasLoaded: true });
    }
  }

  shouldComponentUpdate(nextProps) {
    // Only rerender if not in a unloaded status or the loading has not
    // previously completed.
    const { hasLoaded } = this.state;

    if (
      getLoadedStatus(this.getLoadedStatuses(nextProps)) !== 'UNLOADED' ||
      hasLoaded
    ) {
      return true;
    }
    return false;
  }

  getLoadedStatuses(props = this.props) {
    const { tenancy, contactDetails } = props;
    const loaded = [contactDetails.loaded, tenancy.loaded];
    return loaded;
  }

  getCurrentPage() {
    const { page } = this.props;

    const match = applicationSections.find((child) => {
      return child.slug == String(page);
    });
    if (match) {
      return match;
    }
  }

  render() {
    const {
      goApplicationLanding,
      tenancy,
      contactDetails,
      goDash,
      customerName,
      page,
    } = this.props;

    let tenancyData = {};
    if (tenancy.loaded == 'LOADED') {
      tenancyData = tenancy.data;
    }

    let contactData = {};
    if (contactDetails.loaded == 'LOADED') {
      contactData = contactDetails.data.contactDetails;
    }

    const childCard = (
      <ApplicationChildCard
        contactData={contactData}
        tenancyData={tenancyData}
        customerName={customerName}
        goDash={goDash}
        slug={String(page)}
      />
    );

    const WrappedApplicationChildLayout = withLoader(ApplicationChildLayout);

    return (
      <WrappedApplicationChildLayout
        loaded={this.getLoadedStatuses()}
        backAction={goApplicationLanding}
        card={childCard}
        title={
          page.toLowerCase() == 'fences'
            ? getString(stringsComponent, 'TITLE')
            : page
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  page: state.location.payload.page,
  customerName: `${state.auth.firstName} ${state.auth.lastName}`,
  tenancy: state.customer.tenancy,
  contactDetails: state.customer.contactDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...routingActions,
      ...appActions,
      ...authActions,
      ...customerActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationChild);
